export default function EFARI2(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="MH100详情" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MH100详情-字号调整" transform="translate(-1105.000000, -14993.000000)">
                    <g id="编组-28" transform="translate(470.000000, 14613.000000)">
                        <g id="编组-27" transform="translate(616.000000, 186.000000)">
                            <g id="Take-a-look-at-the-3" transform="translate(0.000000, 185.000000)">
                                <g id="icon/VR-" transform="translate(19.000000, 9.000000)">
                                    <g id="编组" transform="translate(0.000000, -0.000000)">
                                        <path
                                            d="M13.6,0.865467971 L13.6,14.053468 L25.1431172,19.5345715 L24.4568828,20.9799373 L12.7998828,15.445468 L1.14311724,20.9799373 L0.456882761,19.5345715 L11.9998828,14.053468 L12,0.865467971 L13.6,0.865467971 Z"
                                            id="形状结合"
                                            fill="#979797"
                                            fillRule="nonzero"
                                        ></path>
                                        <ellipse id="椭圆形" fill="#8C8C8C" cx="12.7633078" cy="12.8480641" rx="6.83617588" ry="6.84719781"></ellipse>
                                        <path
                                            d="M12.814765,0 L13.1199379,0.12611294 L25.1055391,5.0791728 L25.6,5.28350918 L25.6,20.8067569 L25.0871031,21.0039617 L13.1019058,25.6121753 L12.8151566,25.7224281 L12.5283163,25.6124121 L0.513513563,21.0041985 L0,20.8072431 L0,5.2830191 L0.495086762,5.07891447 L12.5094855,0.125854615 L12.814765,0 Z M24,7.012 L13.565,11.306 L13.61,23.702 L24,19.707468 L24,7.012 Z M1.599,6.809 L1.6,19.706468 L12.01,23.7 L11.964,10.9804053 L1.599,6.809 Z M12.813,1.73046797 L3.156,5.711 L13.061591,9.69787318 L13.167,9.74 L22.701,5.816 L12.813,1.73046797 Z"
                                            id="形状结合"
                                            fill="#FFFFFF"
                                            fillRule="nonzero"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
